// @flow
import React from "react";
import { consts as uploaderConsts } from "uploader";
import { asAbsolute } from "root/routes/utils";
import consts from "../data/consts";
import FacebookTab from "../index";
import ContextPhotos from "../components/ContextPhotos";

export default [{
	path: asAbsolute(uploaderConsts.SOURCES.FACEBOOK),
	component: FacebookTab,
	routes: [
		{
			path: asAbsolute(uploaderConsts.SOURCES.FACEBOOK, "tagged"),
			render: (props: any) => <ContextPhotos
				context={consts.CONTEXTS.TAGGED_PHOTOS} {...props} />,
		},
		{
			path: asAbsolute(uploaderConsts.SOURCES.FACEBOOK, "albums"),
			render: (props: any) => <ContextPhotos
				context={consts.CONTEXTS.ALBUMS}
				selectionAction={(id) => props.history.push({ // navigate to album
					pathname: asAbsolute(uploaderConsts.SOURCES.FACEBOOK, "album", id),
					search: props.location.search,
					hash: props.location.hash,
				})}
				allowSelect={false} {...props} />,
		},
		{
			path: asAbsolute(uploaderConsts.SOURCES.FACEBOOK, "album/:id"),
			render: (props: any) => <ContextPhotos
				context={consts.CONTEXTS.ALBUM_PHOTOS}
				contextId={props.match.params.id} {...props}/>,
		},
	],
}];
